<template>
  <a-row class="userhome" type="flex" justify="center" align="top">
    <a-col :span="4">
      <Usernav class="nav"></Usernav>
    </a-col>
    <!--nav导航-->
    <a-col style="margin-left:5em " :span="18">
      <bread />
      <transition mode="out-in">
        <router-view />
      </transition>
    </a-col>
  </a-row>
  <!-- <div class="userhome">
      <article class="article">
      </article>

  </div> -->
</template>
<script>
import Usernav from "./usercolumn/nav";
import bread from "../bread.vue";
export default {
  name: "user",
  data() {
    return {
      // username: this.$store.state.netuser.netUserName,
      // userimage: this.$store.state.netuser.netUserImage
    };
  },
  components: {
    Usernav: Usernav,
    bread: bread,
  },
  mounted() {},

  methods: {},

  watch: {},
};
</script>

<style lang="less" scoped>
.userhome {
  // width: 100%;
  min-height: 1800px;
  // background-color: cadetblue;
  margin-top: 2%;
  //  用户详情栏
  // .nav {
  //   width: 20%;
  // }
  // .article {
  //   width: 90%;
  // }
  .v-enter,
  .v-leave-to {
    opacity: 0;
    transform: translateY(180deg);
  }
  .v-enter-active,
  .v-leave-active {
    transition: all 0.3s ease;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/user/userindex.vue